const layout = () => import('../../internal/layout.vue')
const concurso = () => import('./concurso.vue')

const concursoRoutes = {
  component: layout,
  children: [
    {
      path: '',
      name: 'concurso',
      meta: {
        title: 'CONCURSO PÚBLICO',
        requiresAuth: true,
      },
      component: concurso,
    },
  ],
}

export default concursoRoutes
